/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// eslint-disable-next-line no-use-before-define
import React, { Dispatch, SetStateAction } from "react";
import classNames from "classnames";
import style from "./styles.module.scss";
import { useIsOverflow } from "hooks/useIsOverflow";
import { ApolloQueryResult, useQuery } from "@apollo/client";
import { GET_ALL_CATEGORIES } from "@graphql/getAllCategories";
import { GetCategories } from "generated/GetCategories";
import { repoQuery, repoQueryVariables } from "generated/repoQuery";
import BlueArrow from "assets/BlueArrow";

interface Props {
	selectedCategory: string | undefined;
	setSelectedCategory: Dispatch<SetStateAction<string>>;
	refetch: (variables?: Partial<repoQueryVariables>) => Promise<ApolloQueryResult<repoQuery>>;
}
export const Filter = ({ selectedCategory, setSelectedCategory, refetch }: Props): JSX.Element => {
	const ref = React.useRef();
	const [step, setStep] = React.useState<number>();
	const [currentPosition, setCurrentPosition] = React.useState<number>(0);
	const hasOverFlow = useIsOverflow(ref, null);
	const { data: categories } = useQuery<GetCategories>(GET_ALL_CATEGORIES);
	const isMobile = typeof window !== "undefined" && window.innerWidth < 720;
	const normalizedCategories = categories?.categories?.edges?.map((category) => category.node.name);
	const filteredCategories = normalizedCategories?.filter((item, pos) => {
		return normalizedCategories.indexOf(item) === pos;
	});

	React.useEffect(() => {
		setStep(isMobile ? 1 : 10);
		if (typeof window !== "undefined") {
			window.addEventListener("resize", () => setStep(isMobile ? 5 : 10));
		}
		return () => window.removeEventListener("resize", () => setStep(isMobile ? 5 : 10));
	}, [step, isMobile]);

	const handleLinkClick = (slug: string) => {
		const categoriesToScroll = ["Tudo", ...filteredCategories];
		const index = categoriesToScroll.findIndex((category) => category === slug);
		setCurrentPosition(index);
		setSelectedCategory(slug === "Tudo" ? undefined : slug);
		refetch({ categoryName: slug === "Tudo" ? undefined : slug });
		const leftBound = document?.getElementById(slug)?.getBoundingClientRect()?.left;
		const step = leftBound;
		document.getElementById("Container").scrollLeft += step - 28.5;
	};

	const handleArrowClick = () => {
		const categoriesToScroll = ["Tudo", ...filteredCategories];
		const length = categoriesToScroll.length;

		if (currentPosition + step >= length) {
			setCurrentPosition(0);
			const size = document.getElementById("Tudo").getBoundingClientRect().left;
			const discount = document.getElementById("Container").getBoundingClientRect().left;
			document.getElementById("Container").scrollLeft += size - discount - 28.5;
		} else {
			setCurrentPosition(currentPosition + 3);
			const size = document.getElementById(categoriesToScroll[currentPosition + step]).getBoundingClientRect().left;
			document.getElementById("Container").scrollLeft += size - 10;
		}
	};

	return (
		<div className={style.Around}>
			<nav className={style.Container} id="Container">
				<ul className={style.Wrapper} id="Wrapper" ref={ref}>
					<li id="Tudo" className={selectedCategory === undefined ? style.SelectedLink : style.Link}>
						<a href="/blogdoamigo">Tudo</a>
					</li>
					{filteredCategories?.map((name) => {
						name = name.normalize("NFD").replace(/[\u0300-\u036f]/g, "");

						return (
							<li key={name} id={name} className={selectedCategory === name ? style.SelectedLink : style.Link}>
								<a href={`${location.origin}/blogdoamigo/categoria/${name.toLocaleLowerCase().split(" ").join("-")}`}>{name}</a>
							</li>
						);
					})}
				</ul>
			</nav>
			{hasOverFlow && (
				<span className={classNames(style.Button)} onClick={handleArrowClick}>
					<BlueArrow />
				</span>
			)}
		</div>
	);
};
